import SaleConfirmationContent from "../../../../src/pages/pricing/contact/sales/sale-confirmation-content.md";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import { GoogleTagManager } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  SaleConfirmationContent,
  NewsLetterBlade,
  GoogleTagManager,
  React
};